import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '@/layout'

export const constantRoutes = [
  {
    path: '/system/doudian-sms',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'report',
        name: 'DoudianSmsReport',
        component: () => import('@/views/system/sms/report/index.vue'),
        meta: { title: '短信触达统计报表', keepAlive: false }
      },
      {
        path: 'resend',
        name: 'DoudianSmsResend',
        component: () => import('@/views/system/sms/resend/index.vue'),
        meta: { title: '配置短信补发', keepAlive: false }
      },
      {
        path: 'link',
        name: 'DoudianSmsLink',
        component: () => import('@/views/system/sms/douLink/index.vue'),
        meta: { title: '短信申请SOP', keepAlive: false }
      },
      {
        path: 'shop',
        name: 'DoudianSmsShop',
        component: () => import('@/views/system/sms/shopList/index.vue'),
        meta: { title: '店铺列表', keepAlive: false }
      },
      {
        path: 'template',
        name: 'DoudianSmsTemplate',
        component: () => import('@/views/system/sms/douTemplate/index.vue'),
        meta: { title: '短信模板列表', keepAlive: false }
      }
    ]
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/refresh/:path(.*)',
    component: () => import('@/views/refresh/index'),
    hidden: true
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/formGenerator',
    name: 'formGenerator',
    component: () => import('@/views/formMaking/index.vue'),
    hidden: true
  },
  {
    path: '/formGeneratorNew',
    name: 'formGeneratorNew',
    component: () => import('@/views/formMakingNew/index.vue'),
    hidden: true
  },
  {
    path: '/pageGenerator',
    name: 'pageGenerator',
    component: () => import('@/views/pageMaking/index.vue'),
    hidden: true
  },
  {
    path: '/questionnaire/preview',
    name: 'QuestionnairePreview',
    component: () => import('@/views/formMakingNew/preview.vue'),
    hidden: true
  },
  {
    path: '/subtitleEditor/:videoGroupId',
    name: 'SubtitleEditor',
    component: () => import('@/views/videoManagement/subtitleEditor/index.vue'),
    hidden: true
  },
  {
    path: '/showSemiVideoDetail/:videoGroupId',
    name: 'ShowSemiVideoDetail',
    component: () =>
      import('@/views/videoManagement/showSemiVideoDetail/index.vue'),
    hidden: true
  },
  {
    path: '/videoEditor',
    name: 'VideoEditor',
    component: () => import('@/views/videoEditor/index.vue'),
    hidden: true,
    meta: {
      keepAlive: false // 设置不缓存
    }
  },
  {
    path: '/videoEditorLive',
    name: 'VideoEditorLive',
    component: () => import('@/views/videoEditorLive/index.vue'),
    hidden: true,
    meta: {
      keepAlive: false // 设置不缓存
    }
  },
  // 直播间
  {
    path: '/liveRoom/:id',
    name: 'liveRoom',
    component: () => import('@/views/live/liveRoom/index.vue'),
    hidden: true,
    meta: {
      keepAlive: false // 设置不缓存
    }
  },
  // 直播间V2
  {
    path: '/liveRoomV2/:id',
    name: 'liveRoomV2',
    component: () => import('@/views/live/liveRoomV2/index.vue'),
    hidden: true,
    meta: {
      keepAlive: false // 设置不缓存
    }
  },
  // 直播看板
  {
    path: '/liveKanban/:id',
    name: 'LiveKanban',
    component: () => import('@/views/live/liveKanban/index.vue'),
    hidden: true,
    meta: {
      keepAlive: false // 设置不缓存
    }
  },
  // 直播脚本配置
  {
    path: '/live/scriptConfiguration/:id',
    name: 'ScriptConfiguration',
    component: () =>
      import('@/views/live/script/scriptConfiguration/index.vue'),
    hidden: true,
    meta: {
      keepAlive: false // 设置不缓存
    }
  },
  // 直播脚本预览
  {
    path: '/live/scriptPreview/:id',
    name: 'ScriptPreview',
    component: () => import('@/views/live/script/scriptPreview/index.vue'),
    hidden: true,
    meta: {
      keepAlive: false // 设置不缓存
    }
  },
  // 直播备课
  {
    path: '/live/prepareLessons/:id',
    name: 'PrepareLessons',
    component: () => import('@/views/live/script/prepareLessons/index.vue'),
    hidden: true,
    meta: {
      keepAlive: false // 设置不缓存
    }
  },
  // AI分享页面
  {
    path: '/ai/share',
    name: 'aiShare',
    component: () => import('@/views/aigc/share/index.vue'),
    hidden: true,
    meta: {
      keepAlive: false // 设置不缓存
    }
  },
  // 客户端免登进入web中转页面
  {
    path: '/desktopToWeb',
    name: 'DesktopToWeb',
    component: () => import('@/views/desktopToWeb/index.vue'),
    hidden: true,
    meta: {
      keepAlive: false // 设置不缓存
    }
  },
  {
    path: '/videoCreate',
    name: 'VideoCreate',
    component: () => import('@/views/videoEditor/create/index.vue'),
    hidden: true,
    meta: {
      keepAlive: false // 设置不缓存
    }
  },
  {
    path: '/smartSalesAi/sidebarBind',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'SmartSalesSidebarBind',
        component: () =>
          import('@/views/smartSalesAi/sidebarBind/index.vue'),
        meta: { title: '企微侧边栏绑定' }
      }
    ]
  },
  {
    path: '/querysite',
    name: 'VuerySite',
    component: () => import('@/views/querySite/index.vue')
  },
  // AI外呼统计（通过按钮跳转）
  {
    path: '/ai-call',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'daily-stat',
        name: 'AiCallDailyStat',
        component: () => import('@/views/aiCall/dailyStat/index.vue'),
        meta: {
          title: 'AI外呼统计',
          keepAlive: false
        }
      }
    ]
  },
  // 收款渠道管理（交易管理下的页面，需要后端配置路由权限）
  {
    path: '/payment',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'channel',
        name: 'PaymentChannel',
        component: () => import('@/views/payment/channel/index.vue'),
        meta: {
          title: '收款渠道管理',
          keepAlive: false
        }
      }
    ]
  }
]

const createRouter = () =>
  new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
